<template>
    <UtilitiesWebView url="/city-tours/accessibility-and-safety" />
</template>
